import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import {
    Chart as ChartJS,
    ArcElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { isEmpty } from 'utils/validationUtil';
import { getMonthName } from 'utils/dateUtil';

ChartJS.register(
    ArcElement,
    Title,
    Tooltip,
    Legend
  );

export function ActivityStatsMonthWisePieChart(props) {
    const [yearMonthList, setYearMonthList] = useState([]);
    const [hoursSpentList, setHoursSpentList] = useState([]);

    async function getData(props) {
        if(isEmpty(props.activityStatsData) || props.activityStatsData.length === 0)
        {
            return [];
        }
            
        // Map contains data like 
        // { "Jan 2023" : 200 }
        var monthwiseHoursMap = new Map();
        props?.activityStatsData.forEach(actStat => {
            const key = getMonthName(actStat.month).substring(0,3) +" "+ actStat.year;
            monthwiseHoursMap.set(key, (monthwiseHoursMap.has(key) ? monthwiseHoursMap.get(key) : 0) + actStat.monthlyHoursSpent);
        });
        return monthwiseHoursMap;
    }

    useEffect(() =>  {
        getData(props)
        .then((map) => {
            const labels = [];
            const data = [];
            if(typeof map !== "undefined")
            for(const entry of map.entries()){
                labels.push(entry[0]); // key
                data.push(entry[1]); // value
            }
            setYearMonthList(labels);
            setHoursSpentList(data);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.activityStatsData]);
    
    const backgroundColors = [
        'rgba(255, 99, 132, 0.3)',
        'rgba(54, 162, 235, 0.3)',
        'rgba(255, 206, 86, 0.3)',
        'rgba(75, 192, 192, 0.3)',
        'rgba(153, 102, 255, 0.3)',
        'rgba(255, 159, 64, 0.3)',
    ];

    const borderColors = [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
    ];

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
            title:{
                fontSize: 14,
                text: props.title,
                display: true ,
                font:{ size:14 }   
            },
            legend:{
                display: false
            }                        
        },                
    };

    const data = {
        labels: yearMonthList,
        datasets: [
            {
                label: 'Hours Spent',
                data: hoursSpentList,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                borderWidth: 1,
                //offset: [20,0,0,0,0,0,0,0,0,0]    
            },
        ],
    };

    if(Object.keys(hoursSpentList).length === 0) //return <div>No sufficient data</div>;
    return <></>
    
    return (
        <div style={{ position: "relative", width: "100%", height: "350px" }}>
            <Pie
                data={data}
                options={options}
            />
        </div>
    );
}

ActivityStatsMonthWisePieChart.propTypes = {
    activityStatsData: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
}